/**
 * The short name a trader recognises a product line by: "VLSFO ISO 8217:2017
 * RMG380 Max.0.50%" for a fuel, the catalogue product for a lube.
 *
 * One builder for every card that names a line on a deal -- the enquiry's
 * Product cards, its Supplier Pricing blocks and the recap's product cards.
 * It used to be typed out three times with a comment asking the copies to
 * agree, and the recap copy had already dropped the free-text sulfur limit.
 * The server's own version is ``contract_shorthand`` (enquiry) and
 * ``fuel_contract_shorthand`` (recap): same order, same lube rule.
 *
 * Returns '' until the line can be named, so the caller decides what an
 * unnamed line shows instead of printing half a name.
 *
 * ``getMixedFuelsShorthand`` in data/mixedFuelsSpec.js is a different name for
 * a different thing (a stock catalogue item's spec slugs), not a deal line.
 */
const findById = (rows, id) => (rows || []).find((r) => r.id === Number(id));

export const productShorthand = (lookups, row) => {
  if (!row) return '';
  if ((row.product_kind || 'bunkers') === 'lubes') {
    return (row.stock_item_variant_display || '').trim();
  }
  const fuelType = findById(lookups?.fuelTypes, row.fuel_type);
  const fuelGrade = findById(lookups?.fuelGrades, row.fuel_grade);
  const sulfur = findById(lookups?.sulfurLimits, row.sulfur_limit);
  const iso = findById(lookups?.iso8217Years, row.iso_8217_year);
  if (!fuelType || !fuelGrade || !sulfur || !iso) return '';
  const sulfurLabel = sulfur.name === 'other'
    ? (row.sulfur_limit_other || 'Other')
    : sulfur.name;
  return `${fuelType.name} ISO 8217:${iso.year} ${fuelGrade.name} ${sulfurLabel}`;
};

export default productShorthand;
